import {
    FJViewCanvasSingleton,
    MOUSE_EVENT_TYPE,
    // MOUSE_EVENT_TYPE,
} from '../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJConstant from '../../constants/FJConstant';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJFileHandleUtil from '../../util/FJFileHandleUtil';
import FJUtil from '../../util/FJUtil';
import { setSliceAiMaskActive, setSliceDisableCompare } from '../slices/FJSliceBrushEditCommon';
import {
    setSliceCreationListAction,
    setSliceFreeNumCreationAction,
    setSliceTaskStatusAction,
} from '../slices/FJSliceCommon';
import {
    OBJECT_ERASE_USE_CREDIT,
    setSliceCurMenuIndex,
    setSliceInputImageInfo,
    setSliceTextEraseInputImageInfo,
} from '../slices/FJSliceObjectErase';
import FJActionBrushEditCommon from './FJActionBrushEditCommon';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';
import { UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE } from '../../config/dataConfig/FJGenerateData';
import FJImageStore from '../../store/FJImageStore';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import { MAX_COMPRESS_IMAGE_SIZE } from '../../config/dataConfig/FJGenerateData.js';
import FJCpmpressedImageStore from '../../store/FJCompressedImageStore.js';
import FJImageManipulationStore from '../../store/FJImageManipulationStore.js';
import FJObjectEraseConfig from '../../config/appConfig/FJObjectEraseConfig.js';

let _curEventId = null;
let _curTextEraseEventId = null;

let _textEraseTaskStatus = FJConstant.DEFAULT;
let _brushEraseTaskStatus = FJConstant.DEFAULT;

let _textEraseCreationList = [];
let _brushEraseCreationList = [];

let _textEraseFreeNumCreation = 0;
let _brushEraseFreeNumCreation = 0;

const _checkIsCurrentTask = (eventId, curEventId = _curEventId) => {
    return curEventId === eventId;
};

const FJActionObjectErase = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceInputImageInfo(null));
            dispatch(FJActionBrushEditCommon.setEditImageAction(null));
            FJViewCanvasSingleton.clear();
            dispatch(setSliceTextEraseInputImageInfo({}));

            _textEraseTaskStatus = FJConstant.DEFAULT;
            _brushEraseTaskStatus = FJConstant.DEFAULT;
            _textEraseCreationList = [];
            _brushEraseCreationList = [];
            _textEraseFreeNumCreation = 0;
            _brushEraseFreeNumCreation = 0;
        };
    },
    /**
     * 上传图片
     * @param {File} file
     */
    uploadImageAction: function (file) {
        return async dispatch => {
            const isGif = FJFileHandleUtil.isGIF(file);
            if (isGif) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }

            const _processImage = async imageInfo => {
                dispatch(this.changeBrushEraseCreationListAction([]));
                dispatch(this.changeObjectEraseTaskStatusAction(FJConstant.DEFAULT));

                setTimeout(() => {
                    dispatch(setSliceAiMaskActive(false));
                    dispatch(setSliceInputImageInfo(imageInfo));
                    // dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.QUICK_SELECTION));
                    dispatch(FJActionBrushEditCommon.setEditImageAction(imageInfo));
                }, 200);
            };

            const isImage = FJUtil.isImage(file, true, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);
            if (!isImage) {
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadImageAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    const transcodedFile = result.files[0];
                    const imageInfo = await FJCompressedImageStore.compressImageByFile(transcodedFile);
                    if (!imageInfo) {
                        throw new Error('compress image failed');
                    }
                    _processImage(imageInfo);
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                    }
                    if (e.cause === FJConstant.CANCELLED) return;
                }
            } else {
                try {
                    const imageInfo = await FJCompressedImageStore.compressImageByFile(file);
                    if (!imageInfo) {
                        throw new Error('compress image failed');
                    }

                    _processImage(imageInfo);
                } catch (error) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                }
            }
        };
    },
    uploadImageUrlAction: function (url, options) {
        return async (dispatch, getState) => {
            try {
                const { size, name, id } = options;
                let data;
                if (size.width > MAX_COMPRESS_IMAGE_SIZE || size.height > MAX_COMPRESS_IMAGE_SIZE) {
                    data = await FJCpmpressedImageStore.compressImageByUrl(url, { name: name }).catch(() => {
                        throw new Error('compress image failed');
                    });
                } else {
                    data = { name: name, src: url, width: size.width, height: size.height, id: id };
                }

                const { curMenuIndex } = getState().objectErase;
                if (curMenuIndex === 0) {
                    dispatch(this.changeBrushEraseCreationListAction([]));
                    dispatch(this.changeObjectEraseTaskStatusAction(FJConstant.DEFAULT));

                    setTimeout(() => {
                        dispatch(setSliceAiMaskActive(false));
                        dispatch(setSliceInputImageInfo(data));
                        dispatch(FJActionBrushEditCommon.setEditImageAction(data));
                        dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.MASK_DRAW));
                    }, 200);
                } else {
                    dispatch(setSliceTextEraseInputImageInfo(data));
                }
            } catch (error) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    /**
     * @desc 上传文本抹除图片
     * @param {File} file
     */
    uploadTextEraseImageAction: function (file) {
        return async dispatch => {
            const isGif = FJFileHandleUtil.isGIF(file);
            if (isGif) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }

            const isImage = FJUtil.isImage(file, true, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);
            if (!isImage) {
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadTextEraseImageAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    file = result.files[0];
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                            'error',
                        );
                    }
                    return;
                }
            }

            try {
                const imageInfo = await FJCompressedImageStore.compressImageByFile(file);
                if (!imageInfo) {
                    throw new Error('compress image failed');
                }
                dispatch(setSliceTextEraseInputImageInfo(imageInfo));
            } catch (error) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    /**
     * @desc 涂鸦抹除生成
     */
    _brashEraseGenerateAction: function () {
        return async (dispatch, getState) => {
            const { inputImageInfo } = getState().objectErase;
            const { creditNumber, freeNumCreation } = getState().common;
            const currentTaskId = new Date().getTime();
            _curEventId = currentTaskId;

            FJUtil.eaLog('object remover remove click', {
                mode: 'custom',
            });

            const __errorCallback = (isShowMessage = true) => {
                if (isShowMessage) {
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                }
                dispatch(this.changeBrushEraseCreationListAction([]));
                dispatch(this.changeObjectEraseTaskStatusAction(FJConstant.DEFAULT));
            };

            const __errorAndReLoad = () => {
                const creationList = _brushEraseCreationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                }));
                dispatch(this.changeBrushEraseCreationListAction(reLoadList));
                dispatch(this.changeObjectEraseTaskStatusAction(FJConstant.ERROR));
            };

            const __judgeCanGenerate = async () => {
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }

                const useCredit = OBJECT_ERASE_USE_CREDIT;

                //免费判断
                const canFreeCreate = _brushEraseFreeNumCreation;

                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                // isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            // 1. 先给反馈开始状态修改
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: 1,
                width: inputImageInfo.width,
                height: inputImageInfo.height,
                type: FJConstant.CREATIONS,
            });
            dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
            dispatch(this.changeBrushEraseCreationListAction(placeHolderList));
            dispatch(this.changeObjectEraseTaskStatusAction(FJConstant.START));

            // 1. 检查编辑图是否准备好
            const editImageBlob = await FJViewCanvasSingleton.getEditImageBlob();
            const originImageBlob = await FJViewCanvasSingleton.getOriginImageBlob();

            if (!editImageBlob || !originImageBlob) {
                __errorCallback();
                return;
            }

            // 3.检查登录、积分
            const canGenerate = await __judgeCanGenerate();
            if (!canGenerate) {
                __errorCallback(false);
                return;
            }

            // 用于编辑页ai工具在执行任务过程中的阻断，不需要做任何处理
            if (!_checkIsCurrentTask(currentTaskId)) {
                return;
            }

            try {
                const maskBlob = await FJViewCanvasSingleton.getMaskImageBlob();
                if (!maskBlob) {
                    __errorCallback();
                    return;
                }

                const editImageS3Url = await FJImageStore.uploadFileByBlob(editImageBlob);
                const originImageS3Url = await FJImageStore.uploadFileByBlob(originImageBlob);

                // 用于编辑页ai工具在执行任务过程中的阻断，不需要做任何处理
                if (!_checkIsCurrentTask(currentTaskId)) {
                    return;
                }

                const maskUrl = await FJImageStore.uploadFileByBlob(maskBlob);

                if (!editImageS3Url || !originImageS3Url || !maskUrl) {
                    __errorCallback();
                    return;
                }

                const __request = async () => {
                    return await FJNetworkStore.objectEraserTask({
                        image: editImageS3Url,
                        mask: maskUrl,
                        original_image: originImageS3Url,
                        prompt: window._prompt || '',
                    });
                };

                const __callback = data => {
                    const { type, waitingEndTime } = data;

                    if (type === FJConstant.ERROR) {
                        __errorAndReLoad();
                    }

                    if (type === FJConstant.SUCCESS) {
                        const creationList = _brushEraseCreationList;
                        const { aiMaskActive } = getState().brushEditCommon;

                        // 成功后替换编辑区域图片
                        if (creationList.length > 0 && !FJUtil.isMobile()) {
                            const creation = creationList[0];
                            dispatch(FJActionBrushEditCommon.resetMaskAction());
                            dispatch(setSliceDisableCompare(false));

                            aiMaskActive && dispatch(FJActionBrushEditCommon.setAiMaskActive(false));
                            dispatch(
                                FJActionBrushEditCommon.setEditImageAction({
                                    src: creation.imgUrl,
                                    creationId: creation.id,
                                    width: creation.width,
                                    height: creation.height,
                                }),
                            );
                        }

                        let _endTime = new Date().getTime();
                        const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);

                        FJUtil.eaLog('object remover generate success', {
                            'generating duration': generatingDuration,
                            mode: 'custom',
                        });
                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };

                // 用于编辑页ai工具在执行任务过程中的阻断，不需要做任何处理
                if (!_checkIsCurrentTask(currentTaskId)) {
                    return;
                }

                const eventId = await FJActionCommon.createRequestTask(__request, dispatch);
                if (!eventId) {
                    __errorCallback(false);
                    return;
                }
                const isFree = creditNumber < 3 && freeNumCreation > 0;
                FJUtil.updateAllCreditInfo(isFree);
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });
                dispatch(
                    FJActionCommon.pollingTaskAction([eventId], {
                        callback: __callback,
                        progressNumber: 1,
                        autoDefaultTaskStatus: !FJUtil.isMobile(),
                        isUseFree: isFree,
                        cusUpdateTaskStatus: type => {
                            dispatch(this.changeObjectEraseTaskStatusAction(type));
                        },
                        cusUpdateCreationList: creationList => {
                            dispatch(this.changeBrushEraseCreationListAction(creationList));
                        },
                    }),
                );
            } catch (error) {
                __errorCallback();
            }
        };
    },

    /**
     * @desc 文本物体抹除生成
     */
    _textEraseGenerateAction: function () {
        return async (dispatch, getState) => {
            const { textEraseInputImageInfo, textPrompt } = getState().objectErase;
            const { creditNumber, freeNumCreation } = getState().common;
            const currentTaskId = new Date().getTime();
            _curTextEraseEventId = currentTaskId;
            let isFree = false;
            FJUtil.eaLog('object remover remove click', {
                mode: 'prompt',
            });

            if (!textEraseInputImageInfo || !textEraseInputImageInfo.src) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                return;
            }

            const __judgeCanGenerate = async () => {
                const _prompt = textPrompt.replace(/\s/g, '');
                if (_prompt.length === 0 || textPrompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    return false;
                }

                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }

                const useCredit = OBJECT_ERASE_USE_CREDIT;

                //免费判断
                const canFreeCreate = freeNumCreation;

                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                isFree = creditNumber < useCredit && canFreeCreate;
                return true;
            };

            const __errorAndClear = () => {
                dispatch(this.changeTextEraseTaskStatusAction(FJConstant.DEFAULT));
                dispatch(this.changeTextEraseCreationListAction([]));
            };

            const __errorAndReLoad = () => {
                const creationList = _textEraseCreationList;
                const reLoadList = creationList.map(i => ({
                    ...i,
                    isLoading: false,
                    isReload: true,
                }));
                dispatch(this.changeTextEraseCreationListAction(reLoadList));
                dispatch(this.changeTextEraseTaskStatusAction(FJConstant.ERROR));
            };

            const canGenerate = await __judgeCanGenerate();
            if (!canGenerate) {
                __errorAndClear(false);
                return;
            }

            // 用于编辑页ai工具在执行任务过程中的阻断，不需要做任何处理
            if (!_checkIsCurrentTask(currentTaskId, _curTextEraseEventId)) {
                return;
            }

            // 1. 先给反馈开始状态修改
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: 1,
                width: textEraseInputImageInfo.width,
                height: textEraseInputImageInfo.height,
                type: FJConstant.CREATIONS,
            });

            dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
            dispatch(this.changeTextEraseCreationListAction(placeHolderList));
            dispatch(this.changeTextEraseTaskStatusAction(FJConstant.START));

            try {
                // 翻译prompt
                const translatedPrompt = await FJNetworkStore.optimizeTranslatePrompt({
                    prompt: textPrompt,
                    // currentLang,
                });

                if (!translatedPrompt) {
                    __errorAndClear();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-translate-prompt'), 'error');
                    return;
                }

                // 用于编辑页ai工具在执行任务过程中的阻断，不需要做任何处理
                if (!_checkIsCurrentTask(currentTaskId, _curTextEraseEventId)) {
                    __errorAndClear();
                    return;
                }

                const s3Url = await FJImageManipulationStore.checkEditImageHasUploadS3(textEraseInputImageInfo.src);
                const imageUrl = s3Url ? s3Url : await FJImageStore.upLoadFileToS3ByUrl(textEraseInputImageInfo.src);

                if (!imageUrl) {
                    __errorAndClear();
                    FJMessageStore.addMessage(FJLocalStore._('failed-to-upload-please-try-again'), 'error');
                    return;
                }

                // 用于编辑页ai工具在执行任务过程中的阻断，不需要做任何处理
                if (!_checkIsCurrentTask(currentTaskId, _curTextEraseEventId)) {
                    __errorAndClear();
                    return;
                }

                const __request = async () => {
                    return await FJNetworkStore.textObjectEraseTask({
                        image: imageUrl,
                        prompt: translatedPrompt,
                        originalPrompt: textPrompt,
                    });
                };

                const eventId = await FJActionCommon.createRequestTask(__request, dispatch);
                if (!eventId) {
                    __errorAndClear(false);
                    return;
                }
                FJUtil.updateAllCreditInfo(isFree);
                FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit' });

                const __callback = data => {
                    const { type, waitingEndTime } = data;

                    if (data.type === FJConstant.ERROR) {
                        __errorAndReLoad();
                    }

                    if (type === FJConstant.SUCCESS) {
                        let _endTime = new Date().getTime();
                        const generatingDuration = FJUtil.getTimeDiff(waitingEndTime, _endTime);

                        FJUtil.eaLog('object remover generate success', {
                            'generating duration': generatingDuration,
                            mode: 'prompt',
                        });

                        FJUtil.eaLog('ai tool generate success', {
                            tool: FJUtil.getToolName(),
                            'credit&free': isFree ? 'free' : 'credit',
                        });
                    }
                };

                dispatch(
                    FJActionCommon.pollingTaskAction([eventId], {
                        callback: __callback,
                        progressNumber: 1,
                        autoDefaultTaskStatus: !FJUtil.isMobile(),
                        isUseFree: isFree,
                        cusUpdateTaskStatus: type => {
                            dispatch(this.changeTextEraseTaskStatusAction(type));
                        },
                        cusUpdateCreationList: creationList => {
                            dispatch(this.changeTextEraseCreationListAction(creationList));
                        },
                    }),
                );
            } catch (error) {
                __errorAndClear();
            }
        };
    },

    /**
     * @desc 改变画笔物体抹除任务状态
     * @param {string} status
     */
    changeObjectEraseTaskStatusAction: function (status) {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().objectErase.curMenuIndex;
            _brushEraseTaskStatus = status;

            if (curMenuIndex === 0) {
                dispatch(setSliceTaskStatusAction(status));
            }
        };
    },

    /**
     * @desc 改变文本物体抹除任务状态
     * @param {string} status
     */
    changeTextEraseTaskStatusAction: function (status) {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().objectErase.curMenuIndex;
            _textEraseTaskStatus = status;
            if (curMenuIndex === 1) {
                dispatch(setSliceTaskStatusAction(status));
            }
        };
    },

    /**
     * @desc 改变文本物体抹除任务列表
     * @param {Array} creationList
     */
    changeTextEraseCreationListAction: function (creationList) {
        return (dispatch, getState) => {
            const { curMenuIndex } = getState().objectErase;
            _textEraseCreationList = creationList;

            if (curMenuIndex === 1) {
                dispatch(setSliceCreationListAction(creationList));
            }
        };
    },

    /**
     * @desc 改变画笔物体抹除任务列表
     * @param {Array} creationList
     */
    changeBrushEraseCreationListAction: function (creationList) {
        return (dispatch, getState) => {
            const { curMenuIndex } = getState().objectErase;
            _brushEraseCreationList = creationList;

            if (curMenuIndex === 0) {
                dispatch(setSliceCreationListAction(creationList));
            }
        };
    },

    /**
     * @desc 改变当前菜单索引
     * @param {number} index
     */
    changeCurMenuIndexAction: function (index) {
        return async dispatch => {
            dispatch(setSliceCurMenuIndex(index));

            if (index === 1) {
                dispatch(setSliceTaskStatusAction(_textEraseTaskStatus));
                dispatch(setSliceCreationListAction(_textEraseCreationList));
                dispatch(setSliceFreeNumCreationAction(_textEraseFreeNumCreation));
            } else if (index === 0) {
                dispatch(setSliceTaskStatusAction(_brushEraseTaskStatus));
                dispatch(setSliceCreationListAction(_brushEraseCreationList));
                dispatch(setSliceFreeNumCreationAction(_brushEraseFreeNumCreation));
            }
        };
    },

    /**
     * @desc 物体抹除生成
     */
    generateAction: function () {
        return async (dispatch, getState) => {
            const { curMenuIndex } = getState().objectErase;
            if (curMenuIndex === 0) {
                dispatch(this._brashEraseGenerateAction());
            } else if (curMenuIndex === 1) {
                dispatch(this._textEraseGenerateAction());
            }
        };
    },

    /**
     * @desc 下载图片
     */
    downloadImageAction: function (callback) {
        return async (dispatch, getState) => {
            const { creationList } = getState().common;
            if (!creationList || creationList.length === 0) {
                callback();
                return;
            }

            dispatch(
                FJActionCommon.multiDownloadAction(
                    creationList.map(item => item.id),
                    'creation',
                    callback,
                ),
            );
        };
    },

    /**
     * @desc 重新生成
     */
    reGenerateAction: function () {
        return async dispatch => {
            dispatch(this.generateAction());
        };
    },

    /**
     * @desc 初始化物体抹除项目
     */
    initObjectEraseProjectAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;

                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadImageAction(file));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(this.uploadImageAction(blob));
                }
            }
        };
    },

    /**
     * @desc 编辑图片加载完成后后执行
     * @returns
     */
    updateEditImageAfterAction: function () {
        return async (dispatch, getState) => {
            const { aiMaskActive } = getState().brushEditCommon;

            const inputImageInfo = getState().objectErase.inputImageInfo;
            if (inputImageInfo) {
                dispatch(FJActionBrushEditCommon.setOriginImageAction(inputImageInfo));
                dispatch(FJActionBrushEditCommon.updateDisableCompareAction());
            }

            if (aiMaskActive) {
                dispatch(
                    FJActionBrushEditCommon.initAiMaskCanvas(() => {
                        FJUtil.isMobile() && FJViewCanvasSingleton.draw();
                    }),
                );
            }
        };
    },

    /**
     * @desc 编辑页内打开ai工具关闭时执行
     */
    editCloseAction: function () {
        return async () => {
            _curEventId = null;
            _curTextEraseEventId = null;
        };
    },

    updateUseFreeLimitAction: function (info) {
        return (dispatch, getState) => {
            const { curMenuIndex } = getState().objectErase;
            _brushEraseFreeNumCreation = info[FJObjectEraseConfig.freeLimitType];
            _textEraseFreeNumCreation = info[FJObjectEraseConfig.promptRemovalFreeLimitType];
            if (curMenuIndex === 0) {
                dispatch(setSliceFreeNumCreationAction(_brushEraseFreeNumCreation));
            } else if (curMenuIndex === 1) {
                dispatch(setSliceFreeNumCreationAction(_textEraseFreeNumCreation));
            }
        };
    },
};

export default FJActionObjectErase;
